import React, { useState } from "react";
import { PencilIcon, XMarkIcon, PhotoIcon } from "@heroicons/react/24/outline";
import { useTranslation } from "react-i18next";
import { getCurrencyAndLanguageSymbol } from "../../constent/currencyUtils";

const CustomBuyForMeCard = ({
  image,
  title,
  // size,
  link,
  count,
  price,
  isEditable,
  status,
  timeLeft,
  // checked,
  // onChange,
  del,
  onShowGallery,
  onEdit,
  images,
}) => {
  const [isHovered, setIsHovered] = useState(false);
  const roundToTwo = (num) => parseFloat(Number(num).toFixed(2));

  const handleMouseEnter = () => setIsHovered(true);
  const handleMouseLeave = () => setIsHovered(false);
  const formattedDate = new Date(timeLeft || "00").toISOString().split("T")[0];
  const { t } = useTranslation();
  const buttonLink = (() => {
    try {
      const url = new URL(link);
      return url.hostname.split(".")[1];
    } catch {
      return "Invalid Link";
    }
  })();

  const currencySymbol = getCurrencyAndLanguageSymbol();

  const truncateText = (text, maxLength) => {
    if (!text) return "";
    return text.length > maxLength ? text.slice(0, maxLength) + "..." : text;
  };
  return (
    <div
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
      className="relative flex flex-col items-center justify-center w-full overflow-hidden border-4 shadow-xl border-gray "
    >
      <div className="relative w-full h-[180px] md:h-[200px] lg:h-[230px]  flex items-center justify-center bg-white">
        <img
          src={image}
          alt={title}
          className="object-contain w-full max-h-full "
        />
        {isHovered && isEditable && (
          <>
            <div className="absolute flex justify-between w-full gap-2 top-2 px-[5%]">
              <button className="p-2 rounded bg-custom-yellow" onClick={onEdit}>
                <PencilIcon className="w-4 h-4 text-black" />
              </button>
              <button className="p-2 bg-black rounded" onClick={del}>
                <XMarkIcon className="w-4 h-4 text-white" />
              </button>
            </div>
            {images?.length > 0 && (
              <div className="absolute flex justify-start w-full gap-2 bottom-2 px-[5%]">
                <button
                  className="p-2 rounded bg-custom-yellow"
                  onClick={onShowGallery}
                >
                  <PhotoIcon className="w-4 h-4 text-black" />
                </button>
              </div>
            )}
          </>
        )}
        {images?.length > 0 && !isEditable && (
          <>
            {images?.length > 0 && (
              <div className="absolute flex justify-start w-full gap-2 bottom-2 px-[5%]">
                <button
                  className="p-2 rounded bg-custom-yellow"
                  onClick={onShowGallery}
                >
                  <PhotoIcon className="w-4 h-4 text-black" />
                </button>
              </div>
            )}
          </>
        )}
      </div>
      <div
        className={`relative flex flex-col items-start justify-center w-full py-3 pe-2 ps-3 md:p-4 transition-colors duration-300  hover:bg-black group hover:text-white bg-custom-yellow text-black group`}
      >
        {/* Desktop */}
        <h2 className="hidden font-bold text-black duration-300 lg:block group-hover:text-white">
          {truncateText(
            typeof title === "object"
              ? title[localStorage.getItem("language") || "en"]
              : title,
            25
          )}
        </h2>
        {/* mobile */}
        <h2 className="block font-bold text-black duration-300 lg:hidden group-hover:text-white">
          {truncateText(
            typeof title === "object"
              ? title[localStorage.getItem("language") || "en"]
              : title,
            12
          )}
        </h2>
        <div className="flex justify-between w-full">
          <p className="text-xs text-black duration-300 group-hover:text-white">
            {t("Count")}: {count}
          </p>
        </div>
        <p className="text-xs text-black duration-300 group-hover:text-white">
          {t("Status")}: {t(`${status}`)}
        </p>
        <p className="my-2 text-xs font-bold text-black duration-300 lg:text-lg group-hover:text-white">
          {t("price")} : {roundToTwo(Number(price))}{" "}
          <span className="text-[9px] lg:text-xs duration-300 text-black group-hover:text-white">
            {currencySymbol}
          </span>
        </p>

        <div className=" flex justify-end w-full sm:relative end-2 bottom-[6px]">
          <a
            href={link}
            target="_blank"
            rel="noopener noreferrer"
            className="px-2 py-1 text-sm text-white duration-300 bg-black rounded-lg md:px-3 group-hover:bg-custom-yellow md:text-base group-hover:text-black"
          >
            {buttonLink}
          </a>
        </div>
      </div>
    </div>
  );
};

export default CustomBuyForMeCard;
